"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _AggregateMetricChartController = require("../common/AggregateMetricCharts/AggregateMetricChartController");
var _ActivitiesAggregatedChart = require("./ActivitiesAggregatedChart");
var _getActivitiesColoring = _interopRequireDefault(require("./getActivitiesColoring"));
var _RestAPI = require("../../API/RestAPI");
var _Spinner = require("../../Core/Spinner");
var _SelectedDevicesController = require("../../Device/SelectedDevicesController");
var _TimeContext = require("../../Time/TimeContext");
var _TimePeriodController = require("../../Time/TimePeriodController");
var _timeAggregationBinMapping = require("../../VIMANAMetrics/timeAggregationBinMapping");
var _getTickXFormatter = require("../common/AggregateMetricCharts/getTickXFormatter");
var _getMetricQuery = require("../common/getMetricQuery");
var _LegendBar = _interopRequireDefault(require("./LegendBar"));
var _stateDetails = require("../UtilizationChart/stateDetails");
var _SelectStates = _interopRequireDefault(require("./SelectStates"));
var _PlantStateActivities = require("../../PlantStateActivities");
var _Core = require("../../Core");
var _utils = require("./dataFormatter/utils");
var _TooltipSortSelect = require("../common/TooltipSortSelect");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
var FlexContainer = _styledComponents["default"].div.withConfig({
  displayName: "ActivitiesChartElement__FlexContainer",
  componentId: "sc-16sa237-0"
})(["display:flex;align-items:flex-end;flex-direction:row;"]);
var FlexColumn = _styledComponents["default"].div.withConfig({
  displayName: "ActivitiesChartElement__FlexColumn",
  componentId: "sc-16sa237-1"
})(["display:flex;flex-direction:column;& > *{padding:5px;}"]);
var FilterRow = _styledComponents["default"].div.withConfig({
  displayName: "ActivitiesChartElement__FilterRow",
  componentId: "sc-16sa237-2"
})(["display:flex;align-items:center;width:100%;"]);
var ErrorText = _styledComponents["default"].div.withConfig({
  displayName: "ActivitiesChartElement__ErrorText",
  componentId: "sc-16sa237-3"
})(["display:block;text-align:center;"]);
function ActivitiesChartElement(props) {
  var width = props.width,
    height = props.height,
    aggregations = props.aggregations,
    _props$showLegends = props.showLegends,
    showLegends = _props$showLegends === void 0 ? true : _props$showLegends,
    _props$tooltipSort = props.tooltipSort,
    tooltipSortProp = _props$tooltipSort === void 0 ? _utils.TOOLTIP_SORT_DESC : _props$tooltipSort;
  var _React$useContext = _react["default"].useContext(_RestAPI.RestAPIContext),
    plantName = _React$useContext.plantName;
  var _React$useContext2 = _react["default"].useContext(_TimeContext.TimeContext),
    timezone = _React$useContext2.timezone;
  var _React$useState = _react["default"].useState([]),
    chartFilters = _React$useState[0],
    setChartFilters = _React$useState[1];
  var _useState = (0, _react.useState)(tooltipSortProp),
    tooltipSort = _useState[0],
    setTooltipSort = _useState[1];
  var device = (0, _SelectedDevicesController.useSelectedDevices)();
  var timePeriod = (0, _TimePeriodController.useSelectionContext)();
  (0, _react.useEffect)(function () {
    setTooltipSort(tooltipSortProp || _utils.TOOLTIP_SORT_DESC);
  }, [tooltipSortProp]);
  var timeAggregationName = (0, _timeAggregationBinMapping.getTimeGroupingNameFromAgg)({
    aggregations: aggregations
  });
  var isTimeAggregated = !!timeAggregationName;
  if (!isTimeAggregated) {
    return /*#__PURE__*/_react["default"].createElement(ErrorText, {
      width: width,
      height: height
    }, "Please select a time aggregation");
  }
  var querySummary = (0, _getMetricQuery.getMetricQuery)({
    plant: plantName,
    interval: timePeriod.interval,
    device: device,
    timezoneName: timezone.name,
    metrics: ["duration_sum"],
    bins: ["states", "activities", "device"]
  });
  var queryMetric = (0, _getMetricQuery.getMetricQuery)({
    plant: plantName,
    interval: timePeriod.interval,
    device: device,
    windowType: timeAggregationName,
    timezoneName: timezone.name,
    metrics: ["duration_sum"],
    bins: ["activities", "states", "device"]
  });
  var tickXFormatter = function tickXFormatter(tickXFormatterProps) {
    return (0, _getTickXFormatter.getXTickFormatter)(Object.assign({
      windowType: timeAggregationName
    }, tickXFormatterProps));
  };
  function ActivitiesDataHandler(_ref) {
    var data = _ref.data,
      fetching = _ref.fetching,
      plantActivities = _ref.plantActivities;
    var activityDetails = (0, _getActivitiesColoring["default"])(data, _stateDetails.stateDetails, plantActivities == null ? void 0 : plantActivities.activities);
    var _useState2 = (0, _react.useState)(activityDetails),
      selectedActivities = _useState2[0],
      setSelectedActivities = _useState2[1];
    var _useState3 = (0, _react.useState)(_stateDetails.stateDetails.filter(function (s) {
        return selectedActivities.find(function (a) {
          return a.state === s;
        });
      })),
      selectedStates = _useState3[0],
      setSelectedStates = _useState3[1];
    (0, _react.useEffect)(function () {
      setSelectedActivities(activityDetails.filter(function (activity) {
        return chartFilters.indexOf(activity.name) > -1;
      }));
    }, [data]);
    (0, _react.useEffect)(function () {
      setSelectedStates(_stateDetails.stateDetails.filter(function (s) {
        return selectedActivities.find(function (a) {
          return a.state === s;
        });
      }));
    }, [selectedActivities]);
    var filterSelectedActivities = function filterSelectedActivities(filteredItems) {
      setSelectedActivities(filteredItems);
      setChartFilters(filteredItems.map(function (activity) {
        return activity.name;
      }));
    };
    if (fetching) return /*#__PURE__*/_react["default"].createElement(_Spinner.Spinner, null);
    if (data.length < 1) return null;
    var legendActivities = (0, _utils.sortLegendActivities)(activityDetails, data, tooltipSort);
    return /*#__PURE__*/_react["default"].createElement(FlexColumn, null, /*#__PURE__*/_react["default"].createElement(_LegendBar["default"], {
      activityDetails: legendActivities,
      selectedActivities: selectedActivities,
      setSelected: filterSelectedActivities,
      width: width - 10,
      showLegendItems: showLegends
    }), /*#__PURE__*/_react["default"].createElement(FlexContainer, null, /*#__PURE__*/_react["default"].createElement(_ActivitiesAggregatedChart.ActivitiesAggregatedChart, _extends({}, props, {
      data: data,
      width: width * 0.3,
      height: height * 0.76,
      activityDetails: activityDetails,
      tickXFormat: function tickXFormat() {
        return " ";
      },
      selectedStates: selectedStates,
      selectedActivities: selectedActivities,
      xAxisLabel: "Summary",
      tooltipSort: tooltipSort
    })), /*#__PURE__*/_react["default"].createElement(_ActivitiesAggregatedChart.ActivitiesAggregatedChart, _extends({}, props, {
      query: queryMetric,
      width: width * 0.65,
      height: height * 0.76,
      aggregations: aggregations,
      activityDetails: activityDetails,
      tickXFormat: tickXFormatter,
      timeAggregationName: timeAggregationName,
      selectedStates: selectedStates,
      selectedActivities: selectedActivities,
      tooltipSort: tooltipSort
    }))));
  }
  return /*#__PURE__*/_react["default"].createElement(_PlantStateActivities.PlantStateActivitiesLoader, null, function (_ref2) {
    var loaded = _ref2.loaded,
      plantActivities = _ref2.data;
    return loaded && /*#__PURE__*/_react["default"].createElement(_AggregateMetricChartController.AggregateMetricChartController, {
      query: querySummary
    }, function (props) {
      return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement(StateFilter, _extends({}, props, {
        plantActivities: plantActivities,
        chartFilters: chartFilters,
        setChartFilters: setChartFilters,
        width: width,
        tooltipSort: tooltipSort,
        onTooltipSortChange: setTooltipSort
      })), /*#__PURE__*/_react["default"].createElement(ActivitiesDataHandler, _extends({}, props, {
        plantActivities: plantActivities
      })));
    });
  });
}
function StateFilter(_ref3) {
  var data = _ref3.data,
    plantActivities = _ref3.plantActivities,
    chartFilters = _ref3.chartFilters,
    setChartFilters = _ref3.setChartFilters,
    width = _ref3.width,
    tooltipSort = _ref3.tooltipSort,
    onTooltipSortChange = _ref3.onTooltipSortChange;
  var _React$useContext3 = _react["default"].useContext(_Core.TranslatorContext),
    translate = _React$useContext3.translate;
  var activityDetails = (0, _getActivitiesColoring["default"])(data, _stateDetails.stateDetails, plantActivities == null ? void 0 : plantActivities.activities);
  (0, _react.useEffect)(function () {
    setChartFilters(activityDetails.map(function (activity) {
      return activity.name;
    }));
  }, [data]);
  var filteredActivities = activityDetails.filter(function (activity) {
    return chartFilters.indexOf(activity.name) > -1;
  });
  var states = (filteredActivities == null ? void 0 : filteredActivities.length) > 0 ? filteredActivities : [{
    name: translate("Widget.ActivitiesChart.NoFilters", "No filters")
  }];
  var sortControlWidth = 160;
  var pickerWidth = Math.max(width - sortControlWidth - 10, 120);
  return /*#__PURE__*/_react["default"].createElement(FilterRow, null, /*#__PURE__*/_react["default"].createElement(_TooltipSortSelect.TooltipSortSelect, {
    tooltipSort: tooltipSort,
    onTooltipSortChange: onTooltipSortChange,
    dataTestId: "ActivitiesChart.TooltipSort"
  }), /*#__PURE__*/_react["default"].createElement(_SelectStates["default"], {
    onSelectItem: function onSelectItem(filteredItems) {
      setChartFilters(filteredItems.map(function (activity) {
        return activity.name;
      }));
    },
    activityDetails: activityDetails,
    selected: states,
    selectedActivities: filteredActivities,
    width: pickerWidth
  }));
}
var _default = exports["default"] = ActivitiesChartElement;